module.exports = __webpack_public_path__ + "static/img/application15-2.b0818b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application15-2.jpg
// module id = 1Epp
// module chunks = 0